// extracted by mini-css-extract-plugin
module.exports = {"error":"resetpasswordclient_error_1Om5d","loginLogo":"resetpasswordclient_loginLogo_2c-wJ","form":"resetpasswordclient_form_1-Zkf"};